import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpellCheckDirective } from './spell-check.directive';
import { SpellCheckSuggestionsModule } from '../../components/spell-check-suggestions/spell-check-suggestions.module';
import { SpellCheckSuggestionsComponent } from '../../components/spell-check-suggestions/spell-check-suggestions.component';

@NgModule({
  declarations: [SpellCheckDirective],
  imports: [
    CommonModule,
    SpellCheckSuggestionsModule
  ],
  exports: [SpellCheckDirective],
  entryComponents: [SpellCheckSuggestionsComponent]
})
export class SpellCheckModule { }

